<template>
  <v-container>
    <!-- <v-tabs class="tabs" height="60px" v-model="activeTab">
      <v-tab v-for="tab in tabs" :key="tab.id" :to="tab.route" exact>
        {{ tab.name }}
      </v-tab>
    </v-tabs> -->
    <router-view></router-view>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      activeTab: `/devices`,
      tabs: [{ id: 1, name: "Devices", route: `/devices` }],
    };
  },
};
</script>
